import { CALLOUT_DEFAULT_WIDTH, TOOLTIP_MAX_WIDTH, type HotspotMarkerData } from '@guidde/design-system/legacy'

import { type HotspotShapeType } from 'app/types'

// Maps the stored hotspot layer (embed model) onto the presentational marker props. Keeps the DS
// components free of the app model — the only place that knows both shapes. Mirrors the producer
// adapter: a layer with no elementType predates the area/callout types and renders as a dot.
export const toHotspotMarker = (layer: HotspotShapeType): HotspotMarkerData => {
    if (layer.elementType === 'callout') {
        return {
            id: layer.id,
            x: layer.x,
            y: layer.y,
            label: layer.label,
            fillColor: layer.fillColor,
            textColor: layer.textColor,
            // The panel has no tooltip: it carries the copy itself and is always shown. These two are
            // part of the shared marker contract, so they're passed as the values the callout implies.
            tooltipPosition: layer.tooltipPosition,
            isOpenByDefault: true,
            tooltipWidth: layer.width || CALLOUT_DEFAULT_WIDTH,
            elementType: 'callout',
            width: layer.width || CALLOUT_DEFAULT_WIDTH,
        }
    }

    if (layer.elementType === 'area') {
        return {
            id: layer.id,
            x: layer.x,
            y: layer.y,
            label: layer.label,
            fillColor: layer.fillColor,
            textColor: layer.textColor,
            tooltipPosition: layer.tooltipPosition,
            isOpenByDefault: layer.openByDefault,
            tooltipWidth: TOOLTIP_MAX_WIDTH,
            elementType: 'area',
            width: layer.width ?? 0,
            height: layer.height,
            strokeWidth: layer.strokeWidth,
            cornerRadius: layer.cornerRadius,
        }
    }

    return {
        id: layer.id,
        x: layer.x,
        y: layer.y,
        label: layer.label,
        fillColor: layer.fillColor,
        textColor: layer.textColor,
        tooltipPosition: layer.tooltipPosition,
        isOpenByDefault: layer.openByDefault,
        tooltipWidth: layer.width || TOOLTIP_MAX_WIDTH,
    }
}
